import axios from 'axios';
import { API_URL } from '../constants/config';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: defaultHeaders,
});

export default api;